import Backend from "i18next-http-backend";
function toError(reason) {
    if (reason instanceof Error)
        return reason;
    return new Error(typeof reason === "string" ? reason : "Translation load failed");
}
class CachedBackend extends Backend {
    cache = new Map();
    cacheExpiry = 1000 * 60 * 60; // 1 hour cache
    loadingPromises = new Map();
    read(language, namespace, callback) {
        const cacheKey = `${language}:${namespace}`;
        // Check if we're already loading this resource
        const existingPromise = this.loadingPromises.get(cacheKey);
        if (existingPromise) {
            void existingPromise.then((data) => callback(null, data), (reason) => callback(toError(reason), null));
            return;
        }
        // Check cache first
        const cached = this.cache.get(cacheKey);
        if (cached) {
            const isExpired = Date.now() - cached.timestamp > this.cacheExpiry;
            if (!isExpired) {
                if (cached.error) {
                    callback(cached.error, null);
                }
                else {
                    callback(null, cached.data);
                }
                return;
            }
            else {
                // Remove expired cache entry
                this.cache.delete(cacheKey);
            }
        }
        // Create loading promise to prevent duplicate requests
        const loadingPromise = new Promise((resolve, reject) => {
            super.read(language, namespace, (error, data) => {
                // Cache the result (both success and error)
                const cacheEntry = {
                    data: data ?? null,
                    timestamp: Date.now(),
                    error: error ?? undefined,
                };
                this.cache.set(cacheKey, cacheEntry);
                // Remove from loading promises
                this.loadingPromises.delete(cacheKey);
                if (error) {
                    reject(toError(error));
                }
                else {
                    resolve(data);
                }
            });
        });
        // Store the loading promise
        this.loadingPromises.set(cacheKey, loadingPromise);
        // Handle the result
        void loadingPromise.then((data) => callback(null, data), (reason) => callback(toError(reason), null));
    }
    // Method to clear cache if needed
    clearCache() {
        this.cache.clear();
        this.loadingPromises.clear();
    }
    // Method to get cache stats for debugging
    getCacheStats() {
        return {
            cacheSize: this.cache.size,
            loadingPromises: this.loadingPromises.size,
            cachedKeys: Array.from(this.cache.keys()),
        };
    }
}
export default CachedBackend;
//# sourceMappingURL=CachedBackend.js.map